import { Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { ResponseFromNestServer, CommonDataModel } from '../../_models/models';
import { IHttpClient, HttpOptions } from '../http-client';
import { ServiceConfig } from '../service-config';
import { ResponseUnwrappingHttpClient } from './response-unwrapping-http-client';

export class RxDealsHttpClient extends ResponseUnwrappingHttpClient {
  constructor(
    httpClient: IHttpClient,
    serviceConfig: ServiceConfig
  ) {
    super(httpClient, serviceConfig.exchangeDealsUrl);
  }

  getExpanded<TResponse>(relativePath: string, options?: HttpOptions): Observable<CommonDataModel<TResponse>> {
    const commonDataModel = new CommonDataModel<TResponse>();
    commonDataModel.isLoading = true;
    commonDataModel.status = 'Fetching';
    return this.httpClient
      .get<ResponseFromNestServer<TResponse>>(this.buildAbsoluteUrl(relativePath), options)
      .pipe(
        map(resFromNestServer => {
          commonDataModel.data = resFromNestServer.data.items;
          commonDataModel.totalElements = resFromNestServer.data.meta?.totalItems ?? 0;
          commonDataModel.isLoading = false;
          commonDataModel.status = 'Success';
          commonDataModel.rxMetaData = resFromNestServer.data.meta;
          return commonDataModel;
        }),
        startWith(commonDataModel),
        catchError(error => {
          commonDataModel.isLoading = false;
          commonDataModel.status = 'Failed';
          commonDataModel.httpErr = error;
          return of(commonDataModel);
        })
      );
  }

  postExpanded<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<CommonDataModel<TResponse>> {
    const commonDataModel = new CommonDataModel<TResponse>();
    commonDataModel.isLoading = true;
    commonDataModel.status = 'Fetching';
    return this.httpClient
      .post<ResponseFromNestServer<TResponse>, TBody>(this.buildAbsoluteUrl(relativePath), body, options)
      .pipe(
        map(resFromNestServer => {
          commonDataModel.data = resFromNestServer.data.items;
          commonDataModel.totalElements = resFromNestServer.data.meta?.totalItems ?? 0;
          commonDataModel.isLoading = false;
          commonDataModel.status = 'Success';
          return commonDataModel;
        }),
        startWith(commonDataModel),
        catchError(error => {
          commonDataModel.isLoading = false;
          commonDataModel.status = 'Failed';
          commonDataModel.httpErr = error;
          return of(commonDataModel);
        })
      );
  }
}
